import { configureStore } from '@reduxjs/toolkit';
import { migrationRedirectMiddleware } from './migrationRedirectMiddleware';
import rootReducer from './reducers/rootReducer';

const store = configureStore({
  devTools: process.env.REACT_APP_MODE !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).prepend(migrationRedirectMiddleware),
  reducer: rootReducer,
});

export default store;
